import superagent from 'superagent'

export const boundariesSet = boundaries => ({
  type: 'BOUNDARIES_SET',
  payload: boundaries
})

export const boundaryCreate = boundary => ({
  type: 'BOUNDARY_CREATE',
  payload: boundary
})

export const boundaryUpdate = id => ({
  type: 'BOUNDARY_UPDATE',
  payload: id
})

export const boundaryDelete = boundary => ({
  type: 'BOUNDARY_DELETE',
  payload: boundary
})

export const boundaryFetchRequest = id => (dispatch, getState, token) => {
  //hunting id is 1
  return new Promise(resolve => {
    superagent
      .get(`${__API_URI__}/mapboundary/get?activityId=1`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          if (err.status == 401) {
            return err.status
          }
        }
        dispatch(boundariesSet(res.body))
        resolve(res.body)
      })
  })
}

export const boundaryCreateRequest = boundaryObj => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .post(`${__API_URI__}/mapboundary/create`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(boundaryObj))
      .end((err, res) => {
        if (err) {
          reject(err)
        } else {
          dispatch(boundaryCreate(res.body))
          resolve(res.body)
        }
      })
  })
}

export const boundaryUpdateRequest = boundaryObj => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .put(`${__API_URI__}/mapboundary/update`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(boundaryObj))
      .end((err, res) => {
        if (err) {
          reject(err)
          if (err.status == 401) {
            return err.status
          }
        }
        dispatch(boundaryUpdate(res.body))
        resolve(res.body)
      })
  })
}

export const boundaryDeleteRequest = id => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .delete(`${__API_URI__}/mapboundary/delete/${id}`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          reject(err)
          if (err.status == 401) {
            return err.status
          }
        }
        dispatch(boundaryDelete(id))
        resolve(res.body)
      })
  })
}
